import Spin from "components/_spin";
import ContractorBox from "components/box/contractor";
import Title from "components/contractor/title";
import { useGetCities, useGetProvinces } from "hooks/useRequest/location/location";
import { FC, useCallback } from "react";
import { ICity } from "rules/interface/city/city.interface";
import { IProvince } from "rules/interface/province/province.interface";
import styles from "./index.module.scss";
import DOMPurify from 'dompurify';


interface IProps {
  contractorCities: string[];
  isDesigner: boolean
}

const SupportCities: FC<IProps> = ({ contractorCities, isDesigner }) => {

  const { data: provincesData, isSuccess: provinceIsSuccess } =
    useGetProvinces();
  const {
    data: citiesData,
    isSuccess: citiesIsSuccess,
    isLoading: citiesIsLoading,
  } = useGetCities({
    enabled: Boolean(!isDesigner),
  });

  const citiesPlacementOrder = useCallback(() => {
    let citiesInProvinceArray = [];
    let citiesArray = [];
    const cities = citiesData?.data?.filter((item: ICity) =>
      contractorCities?.includes(item._id)
    );

    // map on province that includes in city stat
    provincesData?.data
      ?.filter((c: IProvince) =>
        cities?.map((p: ICity) => p.stat)?.includes(c._id)
      )
      ?.map((p: IProvince) => {
        // set all cities on this provinces into a variable
        const citiesInThisProvince = cities?.filter(
          (c: ICity) => c.stat === p._id
        );

        // if selected cities on this provinces equal with all on city into this province
        if (citiesInThisProvince.length === p.countOfCities) {
          citiesInProvinceArray.push(
            `<p>تمامی شهرهای<span>استان ${p.name}</span></p>`
          );
        } else if (
          (citiesInThisProvince.length / p.countOfCities) * 100 >=
          60
        ) {
          const allProvinceCity = citiesData?.data?.filter(
            (res: ICity) => res.stat === p._id
          );
          const uselessCity = allProvinceCity.filter(
            (res: ICity) =>
              !citiesInThisProvince
                .map((city: ICity) => city._id)
                .includes(res._id)
          );

          citiesInProvinceArray.push(
            `<section class="flex align-i-center flex-wrap gap-5">
            <p><span>استان ${p.name
            }</span></p> <div class=${styles.instead__cities}><span>به‌جز</span> ${uselessCity.map(
              (res: ICity) => `${res.name} `
            )}</div>
            </section>`
          );
        } else {
          citiesInThisProvince?.map((item: ICity) =>
            citiesArray.push(`<p>${item.name}</p>`)
          );
        }
      });

    return generateProvinceList([...citiesInProvinceArray, ...citiesArray]);
  }, [citiesIsSuccess, provinceIsSuccess]);

  const generateProvinceList = useCallback((arr: string[]) => {
    // generate list of new array
    return (
      <>
        {arr.map((item: string, index: number) => {
          const sanitizedItem = DOMPurify.sanitize(item || "")

          return (
            item.includes("استان") && (
              <li key={index} dangerouslySetInnerHTML={{ __html: sanitizedItem }} />
            )
          );
        })}

        {arr.map((item: string, index: number) => {
          const sanitizedItem = DOMPurify.sanitize(item || "")

          return (
            !item.includes("استان") && (
              <li key={index} className="inline-block" dangerouslySetInnerHTML={{ __html: sanitizedItem }} />
            )
          );
        })}
      </>
    );
  }, []);

  return (
    <ContractorBox className={styles.cities_box}>
      <Title title="شهرهای تحت پوشش" />

      <div className={styles.wrapper_cities__item + " flex align-i-center"}>
        <span className={styles.location_icon__cities}>
          <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.69373 15.2736C2.00517 13.2568 9.27541e-07 10.2533 9.27541e-07 7.39115C-0.000731378 5.92945 0.432175 4.50039 1.24393 3.28481C2.05569 2.06924 3.20982 1.1218 4.56024 0.562404C5.91066 0.00300427 7.39668 -0.143211 8.83023 0.142263C10.2638 0.427737 11.5804 1.13207 12.6135 2.16612C13.3014 2.85089 13.8466 3.66528 14.2176 4.56215C14.5885 5.45903 14.778 6.42058 14.7749 7.39115C14.7749 10.2533 12.7697 13.2568 11.0812 15.2736C9.95596 16.6165 8.72042 17.863 7.38745 19C6.05448 17.863 4.81893 16.6165 3.69373 15.2736ZM5.14871 5.15242C4.55496 5.74617 4.2214 6.55146 4.2214 7.39115C4.2214 8.23084 4.55496 9.03614 5.14871 9.62989C5.74246 10.2236 6.54776 10.5572 7.38745 10.5572C8.22714 10.5572 9.03244 10.2236 9.62618 9.62989C10.2199 9.03614 10.5535 8.23084 10.5535 7.39115C10.5535 6.55146 10.2199 5.74617 9.62618 5.15242C9.03244 4.55867 8.22714 4.2251 7.38745 4.2251C6.54776 4.2251 5.74246 4.55867 5.14871 5.15242Z" fill="#0130A2" />
          </svg>
        </span>
        <ul id="citiesBox" className={styles.cicites}>
          {
            isDesigner ?
              <li>
                <p>
                  تمام شهرهای <span>ایران</span>
                </p>
              </li>
              :
              citiesIsLoading ? <Spin /> : citiesPlacementOrder()
          }
        </ul>
      </div>
    </ContractorBox>
  );
};

export default SupportCities;
